/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/identityTheftProtectionFamilyMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a IdentityTheftProtectionFamily. */
export class IdentityTheftProtectionFamily {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a IdentityTheftProtectionFamily.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Gets All Family members ITP summary associated with the user
   * @summary Gets all Family Members ITP summary of the caller
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftProtectionFamilyGetAllFamilyUsersItpSummaryResponse>
   */
  getAllFamilyUsersItpSummary(options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftProtectionFamilyGetAllFamilyUsersItpSummaryResponse>;
  /**
   * @param callback The callback
   */
  getAllFamilyUsersItpSummary(callback: coreHttp.ServiceCallback<Models.UserItpSummary[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAllFamilyUsersItpSummary(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserItpSummary[]>): void;
  getAllFamilyUsersItpSummary(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserItpSummary[]>, callback?: coreHttp.ServiceCallback<Models.UserItpSummary[]>): Promise<Models.IdentityTheftProtectionFamilyGetAllFamilyUsersItpSummaryResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAllFamilyUsersItpSummaryOperationSpec,
      callback) as Promise<Models.IdentityTheftProtectionFamilyGetAllFamilyUsersItpSummaryResponse>;
  }

  /**
   * Gets ITP summary of the member associated with the user using csid
   * @summary Get ITP summary of the member with CSID
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftProtectionFamilyGetFamilyMemberItpSummaryResponse>
   */
  getFamilyMemberItpSummary(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.IdentityTheftProtectionFamilyGetFamilyMemberItpSummaryResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  getFamilyMemberItpSummary(csid: string, callback: coreHttp.ServiceCallback<Models.UserItpSummary>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getFamilyMemberItpSummary(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserItpSummary>): void;
  getFamilyMemberItpSummary(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserItpSummary>, callback?: coreHttp.ServiceCallback<Models.UserItpSummary>): Promise<Models.IdentityTheftProtectionFamilyGetFamilyMemberItpSummaryResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      getFamilyMemberItpSummaryOperationSpec,
      callback) as Promise<Models.IdentityTheftProtectionFamilyGetFamilyMemberItpSummaryResponse>;
  }

  /**
   * Request ITP consent of the family member with UserId
   * @summary Request ITP consent of the family member with UserId
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftProtectionFamilyRequestFamilyMemberConsentResponse>
   */
  requestFamilyMemberConsent(options?: Models.IdentityTheftProtectionFamilyRequestFamilyMemberConsentOptionalParams): Promise<Models.IdentityTheftProtectionFamilyRequestFamilyMemberConsentResponse>;
  /**
   * @param callback The callback
   */
  requestFamilyMemberConsent(callback: coreHttp.ServiceCallback<Models.Setting>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  requestFamilyMemberConsent(options: Models.IdentityTheftProtectionFamilyRequestFamilyMemberConsentOptionalParams, callback: coreHttp.ServiceCallback<Models.Setting>): void;
  requestFamilyMemberConsent(options?: Models.IdentityTheftProtectionFamilyRequestFamilyMemberConsentOptionalParams | coreHttp.ServiceCallback<Models.Setting>, callback?: coreHttp.ServiceCallback<Models.Setting>): Promise<Models.IdentityTheftProtectionFamilyRequestFamilyMemberConsentResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      requestFamilyMemberConsentOperationSpec,
      callback) as Promise<Models.IdentityTheftProtectionFamilyRequestFamilyMemberConsentResponse>;
  }

  /**
   * Calls external APIs to register a subscription for the user.
   * @summary Registers a subscriber for the user based on the userId provided in the body
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftProtectionFamilyRegisterSubscriberResponse>
   */
  registerSubscriber(options?: Models.IdentityTheftProtectionFamilyRegisterSubscriberOptionalParams): Promise<Models.IdentityTheftProtectionFamilyRegisterSubscriberResponse>;
  /**
   * @param callback The callback
   */
  registerSubscriber(callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  registerSubscriber(options: Models.IdentityTheftProtectionFamilyRegisterSubscriberOptionalParams, callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  registerSubscriber(options?: Models.IdentityTheftProtectionFamilyRegisterSubscriberOptionalParams | coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>, callback?: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): Promise<Models.IdentityTheftProtectionFamilyRegisterSubscriberResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      registerSubscriberOperationSpec,
      callback) as Promise<Models.IdentityTheftProtectionFamilyRegisterSubscriberResponse>;
  }

  /**
   * Calls external APIs to register a subscription for the user.
   * @summary Registers a subscriber for the user based on the provided information.
   * @param [options] The optional parameters
   * @returns Promise<Models.IdentityTheftProtectionFamilyRegisterSubscriberWithPrimaryDataResponse>
   */
  registerSubscriberWithPrimaryData(options?: Models.IdentityTheftProtectionFamilyRegisterSubscriberWithPrimaryDataOptionalParams): Promise<Models.IdentityTheftProtectionFamilyRegisterSubscriberWithPrimaryDataResponse>;
  /**
   * @param callback The callback
   */
  registerSubscriberWithPrimaryData(callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  registerSubscriberWithPrimaryData(options: Models.IdentityTheftProtectionFamilyRegisterSubscriberWithPrimaryDataOptionalParams, callback: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): void;
  registerSubscriberWithPrimaryData(options?: Models.IdentityTheftProtectionFamilyRegisterSubscriberWithPrimaryDataOptionalParams | coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>, callback?: coreHttp.ServiceCallback<Models.RegisterSubscriberApiResponse>): Promise<Models.IdentityTheftProtectionFamilyRegisterSubscriberWithPrimaryDataResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      registerSubscriberWithPrimaryDataOperationSpec,
      callback) as Promise<Models.IdentityTheftProtectionFamilyRegisterSubscriberWithPrimaryDataResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getAllFamilyUsersItpSummaryOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Family/Summary",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "UserItpSummary"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getFamilyMemberItpSummaryOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Family/Summary/members/{csid}",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.UserItpSummary
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const requestFamilyMemberConsentOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/Family/Consent/members",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.MemberUserIdRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.Setting
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const registerSubscriberOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/Family/members/subscription",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.MemberUserIdRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    201: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const registerSubscriberWithPrimaryDataOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/Family/members/subscription/register/primary",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.MemberUserIdWithPrimaryDataRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    201: {
      bodyMapper: Mappers.RegisterSubscriberApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
